'use client';

import { SectH2, SectLede, V4CtaButton } from '@/components/landing/v4-shared';
import { FacadeVideo } from '@/components/media';
import { VIDEO_EXPLAINER_COPY as COPY } from '@/lib/marketing/messaging-bank';

/**
 * VideoExplainerSection — the homepage explainer video, embedded directly
 * under the hero. Pure consumer of the reusable FacadeVideo primitive +
 * the typed video catalog; all copy resolves from the messaging bank.
 *
 * Rendered as the first deferred homepage section (see
 * DeferredHomepageSections), so its chunk stays out of the initial route
 * graph and the hero keeps the LCP.
 */
export default function VideoExplainerSection() {
  return (
    <section data-v4-section="video-explainer" aria-labelledby="video-explainer-heading">
      <div className="v4-section">
        <div style={{ maxWidth: '720px', margin: '0 auto', textAlign: 'center' }}>
          <SectH2 id="video-explainer-heading" style={{ maxWidth: 'none', margin: '0 auto 20px' }}>
            {COPY.heading}
          </SectH2>
          <SectLede style={{ margin: '0 auto 36px' }}>{COPY.lede}</SectLede>
        </div>

        <div style={{ maxWidth: '900px', margin: '0 auto' }}>
          <FacadeVideo videoId={COPY.videoId} showTranscript />
        </div>

        <div style={{ marginTop: '36px', textAlign: 'center' }}>
          <V4CtaButton href={COPY.ctaHref} size="lg">
            {COPY.ctaLabel}
          </V4CtaButton>
        </div>
      </div>
    </section>
  );
}
